import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Heading } from '@peracto/peracto-ui'
import ConfigForm from './ConfigForm'
import * as S from './styled'
import { Helmet } from 'react-helmet'
import { formatDataForAPI, getReadOnlyFields } from './util'

import { GET_LIST, UPDATE, useClient, getSchemaFromResource } from '@peracto/client'

const Configuration = () => {
    const { client, getResource } = useClient()
    const [loading, setLoading] = useState(true)
    const [redirect, setRedirect] = useState()

    const [configurations, setConfigurations] = useState()

    const fetchConfigurations = async () => {
        try {
            const { data, response } = await client(GET_LIST, 'configurations', {
                id: 'configurations',
            })

            setConfigurations(data)
            setLoading(false)

            if (response && response.status === 404) {
                setRedirect('/configurations')
            }
        } catch (e) {
            console.error(e)
            setRedirect('/configurations')
        }
    }

    useEffect(() => {
        fetchConfigurations()
    }, [])

    const schema = getSchemaFromResource(getResource('configurations'))

    const onSubmit = async (data, actions) => {
        const dataClone = { ...data.values }
        // TODO: get way of individiual fields to be excluded from data and applied programatically
        if (dataClone?.location_types) {
            delete dataClone.location_types
        }

        const readOnlyFields = getReadOnlyFields(configurations)
        const formattedData = formatDataForAPI(dataClone, readOnlyFields)

        try {
            const response = await client(UPDATE, 'configurations', {
                data: {
                    values: formattedData,
                },
                id: data.id,
            })

            if (response.data.violations && response.data.violations.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                response.data.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            } else {
                actions.setSubmitting(false)
                fetchConfigurations()
                toast.success('Configuration successfully updated!')
            }
        } catch (e) {
            console.error(e)
            actions.resetForm()
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )
            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                e.error.body.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            }
            actions.setSubmitting(false)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    const tabs = configurations?.map(section => (
        <Tab key={`${section.section}-tab`}>{section.name}</Tab>
    ))

    const forms = configurations?.map(config => (
        <TabPanel key={config.section}>
            <ConfigForm
                values={config}
                readOnly={config?.readOnly}
                onSubmit={onSubmit}
                schema={schema}
            />
        </TabPanel>
    ))

    return (
        <>
            <Helmet>
                <title>Settings | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Settings" />

                {loading ? (
                    <div className="card">
                        <div className="card-body">Loading...</div>
                    </div>
                ) : (
                    <S.TabsContainer>
                        <Tabs>
                            <TabList>{tabs}</TabList>

                            {forms}
                        </Tabs>
                    </S.TabsContainer>
                )}
            </div>
        </>
    )
}

export default Configuration
